// extracted by mini-css-extract-plugin
export default {"list":"Tabs_list__SjoFI","indicator":"Tabs_indicator__NwZoM","tab":"Tabs_tab__l2nrf","panel":"Tabs_panel__i-zsn"};